import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { createTheme as createMuiTheme, ThemeProvider as MuiThemeProvider } from '@mui/material/styles';
import stripUnit from 'polished/lib/helpers/stripUnit';
import React from 'react';
import { ThemeProvider } from 'styled-components';
import { replaceCssVars } from "./replaceCssVars.js";
import { GlobalStyles } from "./GlobalStyles.js";
import { theme } from "./theme.js";
import { transformToCssVars } from "./kallistoTheme/utils/transformToCssVars.js";
export var DynamicLmnDsThemeProvider = function DynamicLmnDsThemeProvider(_ref) {
  var themeTokens = _ref.themeTokens,
    children = _ref.children,
    _ref$reset = _ref.reset,
    reset = _ref$reset === void 0 ? true : _ref$reset,
    _ref$useCssVars = _ref.useCssVars,
    useCssVars = _ref$useCssVars === void 0 ? true : _ref$useCssVars,
    _ref$isDarkMode = _ref.isDarkMode,
    isDarkMode = _ref$isDarkMode === void 0 ? false : _ref$isDarkMode,
    kallistoTheme = _ref.kallistoTheme;
  var currentThemeTokens = themeTokens;
  var currentTheme = theme;
  currentTheme.brandName = currentThemeTokens['brand-name'];
  currentTheme.themeName = currentThemeTokens['theme-name'];
  var _replaceCssVars = replaceCssVars(currentTheme, currentThemeTokens),
    _replaceCssVars2 = _slicedToArray(_replaceCssVars, 2),
    themeTokensWithoutVars = _replaceCssVars2[0],
    themeWithoutVars = _replaceCssVars2[1];
  if (!useCssVars) {
    currentThemeTokens = themeTokensWithoutVars;
    currentTheme = themeWithoutVars;
  }
  currentTheme.tokensWithValues = themeTokensWithoutVars;

  // Get the appropriate Kallisto theme
  var selectedKallistoTheme = isDarkMode ? kallistoTheme === null || kallistoTheme === void 0 ? void 0 : kallistoTheme.dark : kallistoTheme === null || kallistoTheme === void 0 ? void 0 : kallistoTheme.light;
  if (selectedKallistoTheme) {
    if (useCssVars) {
      currentTheme.kallisto = _objectSpread(_objectSpread({}, selectedKallistoTheme), {}, {
        font: transformToCssVars(selectedKallistoTheme.font, 'font'),
        color: transformToCssVars(selectedKallistoTheme.color, 'color'),
        radius: transformToCssVars(selectedKallistoTheme.radius, 'radius')
      });
    } else {
      currentTheme.kallisto = selectedKallistoTheme;
    }
  }
  var muiTheme = createMuiTheme(_objectSpread(_objectSpread({}, currentTheme), {}, {
    components: {
      MuiButtonBase: {
        defaultProps: {
          disableRipple: true
        }
      }
    },
    typography: {
      fontFamily: currentThemeTokens['font-family'],
      fontSize: stripUnit(currentThemeTokens['font-size-base']),
      fontWeightRegular: currentThemeTokens['font-weight-regular'],
      fontWeightMedium: currentThemeTokens['font-weight-semiBold'],
      fontWeightBold: currentThemeTokens['font-weight-bold']
    }
  }));
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(GlobalStyles, {
    theme: currentTheme,
    themeTokens: currentThemeTokens,
    shouldResetStyles: reset,
    useCssVars: useCssVars,
    kallistoTokens: selectedKallistoTheme
  }), /*#__PURE__*/React.createElement(ThemeProvider, {
    theme: currentTheme
  }, /*#__PURE__*/React.createElement(MuiThemeProvider, {
    theme: muiTheme
  }, children)));
};